import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import apiClient from '../../../apiClient';
import { IQueue, IRFS } from '../../../globals/interfaces';

export interface CounterAwb extends IQueue {
    rfs?: IRFS;
}

export default function useAwbs (
    s_counter_ownership_agent: string,
    s_unit: string,
    s_type: string,
    refresh: boolean
) {

    const [awbs, setAwbs] = useState<Array<CounterAwb>>([]);
    const [awbsLoading, setAwbsLoading] = useState<boolean>(true);
    const history = useHistory();

    useEffect(() => {
        const awbsQuery = async() => {
            const res = await apiClient.post('/agentAwbs', {
                s_counter_ownership_agent,
                s_unit,
                s_type
            });

            const { data } = res;

            if (
                (_.get(history, 'location.search.length', 0) > 0) && 
                data.length > 0
            ) {
                const s_mawb = history.location.search.split('=')[1];
                const index = data.findIndex((a: any) => a.s_mawb === s_mawb);
                data.unshift(data.splice(index, 1)[0]);
            }
   
            setAwbs(data);
            setAwbsLoading(false);
        };

        if (s_counter_ownership_agent && s_unit && s_type) {
            awbsQuery();
        }
    }, [s_counter_ownership_agent, s_unit, s_type, refresh]);

    useEffect(() => {
        if (!awbsLoading && !awbs.length) {
            history.push('/EOS/Operations/Counter/Queue');
        }
    }, [awbs, awbsLoading]);

    return {
        awbsLoading, 
        awbs
    };
}
